import { memo, forwardRef, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Swimlane, SwimlaneCumulationData } from '../../Kanban'
import { SwimlaneSectionHeader } from './SwimlaneSectionHeader'

type Props = PropsWithChildren<{
  swimlane: Swimlane
  cumulation: SwimlaneCumulationData
  isCollapsed: boolean
  onToggleCollapse: () => void
  isDimmed?: boolean // ドラッグ中に他のスイムレーンを薄くするかどうか
}>

const SwimlaneRowInner = forwardRef<HTMLDivElement, Props>(
  (
    {
      swimlane,
      cumulation,
      isCollapsed,
      onToggleCollapse,
      isDimmed = false,
      children,
    },
    ref
  ) => {
    return (
      <SwimlaneContainer ref={ref} isDimmed={isDimmed}>
        <SwimlaneSectionHeader
          swimlane={swimlane}
          cumulation={cumulation}
          isCollapsed={isCollapsed}
          onToggleCollapse={onToggleCollapse}
        />
        {!isCollapsed && <SwimlaneCardsRow>{children}</SwimlaneCardsRow>}
      </SwimlaneContainer>
    )
  }
)

export const SwimlaneRow = memo(SwimlaneRowInner)

const SwimlaneContainer = styled('div')<{ isDimmed: boolean }>(props => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  opacity: props.isDimmed ? 0.4 : 1,
  transition: 'opacity 0.15s ease',
  pointerEvents: props.isDimmed ? 'none' : 'auto',
}))

const SwimlaneCardsRow = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '8px',
})
